import { WhiteboardController } from "@/wbcontroller/WhiteboardController";
import { WBState } from "./stateInterfaceType";
import ControllerCache from "./ControllerCache";

export interface WBStoreGetters {
  wbid: string;
  wbcontroller: WhiteboardController;
}

const getters = {
  wbid(state: WBState): string {
    return state.whiteboard.wbid;
  },

  wbcontroller(state: WBState): WhiteboardController {
    return ControllerCache[state.whiteboard.wbid];
  },

  isDemo(state: WBState) {
    return state.whiteboard.wbid === "demo";
  },

  // slide deck navigation
  nextFolderWbid(state: WBState): string | null {
    return state.folderNavigation.next.get(state.whiteboard.wbid) || null;
  },
  previousFolderWbid(state: WBState): string | null {
    return state.folderNavigation.previous.get(state.whiteboard.wbid) || null;
  },
  hasFolder(state: WBState): boolean {
    return !!state.folder;
  },
  hasNextFolderWbid(state: WBState): boolean {
    return state.folderNavigation.next.get(state.whiteboard.wbid) != null;
  },
  hasPreviousFolderWbid(state: WBState): boolean {
    return state.folderNavigation.previous.get(state.whiteboard.wbid) != null;
  },
  folderIndex(state: WBState): number {
    return state.folderNavigation.index.get(state.whiteboard.wbid) || -1;
  },
};
export default getters;
